import { Button } from '@mui/material';
import React, { Component } from 'react';
import './style.css';

class PersonalDetails extends Component {
  continue = e => {
    e.preventDefault();
    const isFirstNameValid = this.props.validateFirstName();
    const isLastNameValid = this.props.validateLastName();
    if (isFirstNameValid && isLastNameValid) {
      this.props.nextStep();
    }
  };

  render() {
    const {
      firstname,
      lastname,
      middlename,
      email,
      phone,
      handleChange,
      validateFirstName,
      validateLastName,
      isErrorFirstName,
      isErrorLastName,
      errorMessageFirstName,
      errorMessageLastName,
      residentialType,
      residencyStatus,
      gender,
      dateOfBirth,
    } = this.props;

    return (
      <div className="form">
        <form>
          <div className="form-group">
            <div className="form-group__element">
              <label htmlFor="first name" className="form-group__label">
                First name <font color="red">*</font>
              </label>
              <input
                type="text"
                value={firstname}
                name="first name"
                onChange={handleChange('firstname')}
                onBlur={validateFirstName}
                className="form-group__input"
              />
              <p className="error">{isErrorFirstName && errorMessageFirstName}</p>
            </div>
            <div className="form-group__element">
              <label htmlFor="middle name" className="form-group__label">
                Middle name
              </label>
              <input
                type="text"
                value={middlename}
                name="middle name"
                onChange={handleChange('middlename')}
                className="form-group__input"
              />
            </div>

            <div className="form-group__element">
              <label htmlFor="last name" className="form-group__label">
                Last name <font color="red">*</font>
              </label>
              <input
                type="text"
                value={lastname}
                name="last name"
                onChange={handleChange('lastname')}
                onBlur={validateLastName}
                className="form-group__input"
              />
              <p className="error">{isErrorLastName && errorMessageLastName}</p>
            </div>

            <div className="form-group__element">
              <label htmlFor="email" className="form-group__label">
                Email <font color="red">*</font>
              </label>
              <input
                type="email"
                value={email}
                name="email"
                onChange={handleChange('email')}
                className="form-group__input"
              />
            </div>

            <div className="form-group__element">
              <label htmlFor="phone" className="form-group__label">
                Phone <font color="red">*</font>
              </label>
              <input
                type="text"
                value={phone}
                name="phone"
                onChange={handleChange('phone')}
                className="form-group__input"
              />
            </div>
            <div className="form-group__element">
              <label htmlFor="gender" className="form-group__label">
                Gender
              </label>
              <select className="form-group__select" value={gender} onChange={handleChange('gender')}>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Unspecified">Unspecified</option>
              </select>
            </div>
            <div className="form-group__element">
              <label htmlFor="phone" className="form-group__label">
                Residential Type
              </label>
              <select className="form-group__select" value={residentialType} onChange={handleChange('residentialType')}>
                <option value="Mortgage">Mortgage</option>
                <option value="Own">Own</option>
                <option value="Rent">Rent</option>
                <option value="Rent">HNZ</option>
                <option value="Rent">Board</option>
              </select>
            </div>
            <div className="form-group__element">
              <label htmlFor="phone" className="form-group__label">
                Are you a New Zealand Resident
              </label>
              <select className="form-group__select" value={residencyStatus} onChange={handleChange('residencyStatus')}>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div className="form-group__element">
              <label htmlFor="dateOfBirth" className="form-group__label">
                Date of birth
              </label>
              <input
                name="dateOfBirth"
                type="date"
                className="form-group__input"
                value={dateOfBirth}
                onChange={handleChange('dateOfBirth')}
              />
            </div>
          </div>

          <div style={{ textAlign: 'center' }}>
            <Button variant="contained" sx={{ backgroundColor: '#b4855a' }} onClick={this.continue}>
              Next
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default PersonalDetails;
